import {Pinia} from 'pinia'
import {useMobileNotificationsStore} from '@toolify/client/src/stores/MobileNotificationsStore/useMobileNotificationsStore'
import {useMobileAppStore} from '@toolify/client/src/stores/MobileAppStore/useMobileAppStore'
import {useAppLayoutStore} from '@toolify/client/src/stores/AppLayoutStore/useAppLayoutStore'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'
import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {App} from '@capacitor/app'

export function checkRecentLinkToNavigateRouterHookFactory(pinia: Pinia) {
  return async function checkRecentLinkToNavigateRouterHook() {
    const mobileNotificationsStore = useMobileNotificationsStore(pinia)
    const mobileAppStore = useMobileAppStore(pinia)
    const {currentAppPlatformType} = useCurrentAppPlatform()
    if(currentAppPlatformType === AppPlatformType.Mobile && !mobileAppStore.hasLaunchUrlBeenDetermined) {
      const launchUrl = await App.getLaunchUrl()
      mobileAppStore.hasLaunchUrlBeenDetermined = true
      if(launchUrl?.url) {
        return mobileAppStore.convertAppLaunchUrlToPath(launchUrl.url)
      }
    }
    if(mobileNotificationsStore.recentLinkToNavigate) {
      const linkToNavigate = mobileNotificationsStore.recentLinkToNavigate
      mobileNotificationsStore.recentLinkToNavigate = null
      const appLayoutStore = useAppLayoutStore(pinia)
      appLayoutStore.isSideNavigationOpen = false
      appLayoutStore.isSettingsSidebarOpen = false
      return linkToNavigate
    }
    return
  }
}
